import React from "react";

import { Navbar } from "../../../components";
import { Chapter } from "./Chapter";

const ChapterProject = () => {
  return (
    <div className="app">
      <Navbar />
      <Chapter />
    </div>
  );
};

export default ChapterProject;
